import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes, TextareaHTMLAttributes } from "react";

const CLASE_BASE =
  "block w-full rounded-lg border border-borde px-3 py-2 text-sm text-texto placeholder:text-texto-secundario focus:border-secundario focus:outline-none focus:ring-1 focus:ring-secundario disabled:bg-fondo disabled:text-texto-secundario";

export function Campo({
  etiqueta,
  error,
  obligatorio,
  children,
}: {
  etiqueta: string;
  error?: string;
  obligatorio?: boolean;
  children: ReactNode;
}) {
  return (
    <label className="block">
      <span className="mb-1 block text-sm font-medium text-texto">
        {etiqueta}
        {obligatorio && <span className="text-error"> *</span>}
      </span>
      {children}
      {error && <span className="mt-1 block text-xs font-medium text-error">{error}</span>}
    </label>
  );
}

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`${CLASE_BASE} ${props.className ?? ""}`} />;
}

export function TextArea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={`${CLASE_BASE} ${props.className ?? ""}`} />;
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={`${CLASE_BASE} bg-superficie ${props.className ?? ""}`} />;
}

export function CampoBusqueda({
  valor,
  onCambio,
  placeholder = "Buscar...",
}: {
  valor: string;
  onCambio: (v: string) => void;
  placeholder?: string;
}) {
  return (
    <div className="relative w-full max-w-xs">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-texto-secundario">⌕</span>
      <input
        value={valor}
        onChange={(e) => onCambio(e.target.value)}
        placeholder={placeholder}
        className={`${CLASE_BASE} pl-8`}
      />
    </div>
  );
}
